import { InputMaybe, MarketplaceAppOrder } from '@/generated/contentful'

export type AppType = 'featured' | 'recommended' | 'top-free' | 'top-paid' | 'newest'

export const ALGOLIA_APPS_HITS_PER_PAGE = 12

export function getAppParams(type: AppType): {
	where?: {
		featured?: boolean | undefined
		recommended?: boolean | undefined
		pricingType?: string | undefined
		pricingType_not?: string | undefined
	}
	order: InputMaybe<MarketplaceAppOrder>
} {
	switch (type) {
		case 'featured': {
			return {
				where: { featured: true },
				order: MarketplaceAppOrder.FeaturedOrderDesc
			}
		}
		case 'recommended': {
			return {
				where: { recommended: true },
				order: MarketplaceAppOrder.RecommendedOrderDesc
			}
		}

		case 'top-free': {
			return {
				where: { pricingType: 'Free' },
				order: MarketplaceAppOrder.RankDesc
			}
		}

		case 'top-paid': {
			return {
				where: { pricingType_not: 'Free' },
				order: MarketplaceAppOrder.RankDesc
			}
		}

		case 'newest': {
			return {
				order: MarketplaceAppOrder.ApprovedAtDesc
			}
		}
	}
}
